
import React, { useState, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import Styles from './Unsubscribe_SA.module.scss'
import Button from '../../Buttons/Button';
import virtualmente from '../../../images/ImagesSA/virtualmente.png';
import { putUnsubscribed } from "../../../store/account/thunks";
import { connect } from "react-redux";
import { ApiResponse } from "../../../services/types";
import CardContainer from '../../Card/CardContainer';
import MessagePopUpTemporal from '../../ModalPopUp/MessagePopUpTemporal';
import classnames from 'classnames';


interface UnsubscribeProps {
    putUnsubscribed?: any
}
const Unsubscribe: React.FC<UnsubscribeProps> = (props: UnsubscribeProps) => {
    const [showPopUp, setshowPopUp] = useState(false);
    const { token } = useParams();
    const Cancel = async () => {
        const response: ApiResponse = await props.putUnsubscribed(token);
            if (response.StatusCode === 200) {
                setshowPopUp(true);
                setTimeout(() => {
                    setshowPopUp(false);
            }, 1000)
        }
    }

    return (
        <div className="container mb-5 mt-4">
            <div className="row mb-5 mt-4 text-center">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <img src={virtualmente} className="img-fluid" alt="Imagen virtualmente juntos"/>
                </div>
            </div>
             <div className="row mb-4 mt-4 text-center">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <h5 className={Styles.title}> Confirmación de cancelación</h5>
                </div>
            </div>
            <CardContainer className="col-lg-6 col-md-6 col-sm-6 col-xs-12 mt-3">
                <Fragment>
                    <h6 className={Styles.parrafo}>
                        De acuerdo con tu solicitud, confirma la cancelación
                        de tu suscripción para ya no recibir más correos
                    </h6>
                    <div className="row mb-4">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                            <Button
                                id="btnCancel"
                                onClick={Cancel}
                                styleClass= {classnames(Styles.size, "mt-2")}
                                textoButton="Cancelar suscripción"
                            />
                        </div>
                    </div>
                </Fragment>
            </CardContainer>
            <div style={{ display: (showPopUp ? 'block' : 'none') }}>
                <MessagePopUpTemporal
                    message={<Fragment>Se ha cancelado su suscripción,ya no recibira mas mensajes</Fragment>}
                    classNameStyle={classnames(Styles.message, "col-lg-8 col-md-8 col-sm-8 col-xs-8")}
                />
            </div>
        </div>
  );
};
export default connect(null, { putUnsubscribed })(Unsubscribe);
